import { DOCUMENT } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { PermissionConst } from 'src/app/core/models/permission-const.model';
import { ProfessionModel } from 'src/app/core/models/profession.model';
import { RegistersService } from 'src/app/core/services/registers.service';
import { SessionManagerService } from 'src/app/core/services/session-manager.service';
import { ConfirmationModalComponent } from 'src/app/shared/components/modals/confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-profession-form',
  templateUrl: './profession-form.component.html',
  styleUrls: ['./profession-form.component.scss']
})
export class ProfessionFormComponent implements OnInit {


  formGroup = this.fb.group({
    id: [],
    name: ['']
  });

  get clinicId() {
    if (this.sessionManager.isSuperUserOrStaff()) {
      return '';
    }
    return this.sessionManager.getClinicCurrent().value?.toString();
  }

  constructor(@Inject(DOCUMENT) private document: Document, private activatedRoute: ActivatedRoute, private fb: FormBuilder,
    private router: Router, config: NgbModalConfig, private modalService: NgbModal, private registersService: RegistersService,
    private sessionManager: SessionManagerService, private toast: ToastrService) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  isRegister: boolean = true;
  submitting: boolean = false;
  submittingRemove: boolean = false;
  removeButton: String = "Desativar";
  submitButton: String = "Salvar";
  button: boolean = false;

  id!: number;
  existingProfessionData!: ProfessionModel;
  fetchingProfession: boolean = false;

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.id = params["id"];
      if (this.id) {
        this.isRegister = false;
      }
    });
    this.initializeForm();
  }

  initializeForm() {
    if (this.id) setTimeout(() => this.fetchProfessionExistingData(), 1000);
  }

  get fetchingData(): boolean {
    if (this.isRegister) {
      return true;
    } else {
      if (this.fetchingProfession) return true;
    }
    return false;
  }

  get canSave() {
    if (this.id) {
      return this.sessionManager.getUserPermission(PermissionConst.add_profession);
    } else {
      return this.sessionManager.getUserPermission(PermissionConst.change_profession);
    }
  }

  get canRemove() {
    return this.sessionManager.getUserPermission(PermissionConst.remove_profession);
  }

  cancelHandler() {
    this.router.navigate(['dashboard/registers/professions']);
  }

  fetchProfessionExistingData() {
    this.registersService.professionGet(this.clinicId, this.id).subscribe(response => {
      this.existingProfessionData = response;
      this.formGroup.patchValue(this.existingProfessionData);
      if (this.existingProfessionData.is_active) {
        this.removeButton = "Desativar";
        this.submitButton = "Salvar";
        this.button = true;
      } else {
        this.button = false;
        this.submitButton = "Reativar";
        this.formGroup.disable();
      }
      this.fetchingProfession = true;
    }, (error) => {
      const response = error as HttpErrorResponse;
      this.mapErrorResponse(response);
    });
  }

  removeHandler() {
    this.submittingRemove = true;
    const modalRef = this.modalService.open(ConfirmationModalComponent, { centered: true });
    modalRef.componentInstance.text = "Deseja desativar esta profissão?";
    modalRef.result.then((result) => {
      if (result == true) {
        this.registersService.professionRemove(this.clinicId, this.id).subscribe(() => {
          this.toast.success('Profissão removida com sucesso', "Sucesso");
          this.cancelHandler();
        }, (errorResponse: HttpErrorResponse) => {
          this.submittingRemove = false;
          this.mapErrorResponse(errorResponse);
        });
      } else {
        this.submittingRemove = false;
      }
    });
  }

  submitHandler() {
    this.formGroup.markAllAsTouched();
    this.submitting = true;

    let professionData = this.formGroup.getRawValue() as ProfessionModel;
    if (this.isRegister) {
      this.professionRegister(professionData);
    } else {
      this.professionEdit(professionData);
    }
  }

  professionEdit(professionData: ProfessionModel) {
    professionData.is_active = true;
    this.registersService.professionEdit(this.clinicId, professionData).subscribe(res => {
      this.toast.success('Profissão alterada com sucesso', 'Sucesso');
      this.submitting = false;
      this.cancelHandler();
    }, (error) => {
      const response = error as HttpErrorResponse;
      this.mapErrorResponse(response);
      this.submitting = false;
    });
  }

  professionRegister(professionData: ProfessionModel) {
    professionData.id = undefined;
    this.registersService.professionRegister(this.clinicId, professionData).subscribe(res => {
      this.toast.success('Profissão alterada com sucesso', 'Sucesso');
      this.submitting = false;
      this.cancelHandler();
    }, (error) => {
      const response = error as HttpErrorResponse;
      this.mapErrorResponse(response);
      this.submitting = false;
    });
  }

  mapErrorResponse(errorResponse: HttpErrorResponse) {
    if (errorResponse.error["detail"]) {
      this.toast.error(errorResponse.error["detail"], "Erro");
      this.document.getElementById('main-container')?.scroll({ top: 0 });
    } else {
      this.setFormErrors(errorResponse);
      this.document.getElementById('main-container')?.scroll({ top: 0 });
    }
  }

  setFormErrors(errorResponse: HttpErrorResponse) {
    let errNames = [
      "id", "name", "type"
    ];

    errNames.forEach(name => {
      if (errorResponse.error[name]) {
        this.formGroup.get(name)?.setErrors({ response: errorResponse.error[name] });
      }
    });
  }

  canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
    return true;
  };

}
